export enum EDefaultMetaTags {
  Title = 'Oferty Rainbow - Wycieczki, Wyjazdy, Wakacje, Wczasy',
  Description = 'Najlepsze oferty last minute, wczasy i tanie wycieczki objazdowe. Wypoczynek w hotelach All Inclusive. Rezerwuj wakacje marzeń!',
}
